(function () {
  'use strict';

  function initPortal() {
    var portal = document.querySelector('[data-joven-portal-nav]');
    if (!portal) return;
    if (portal.getAttribute('data-joven-initialized') === 'true') return;
    portal.setAttribute('data-joven-initialized', 'true');

    document.documentElement.classList.add('joven-portal-active');
    document.body.classList.add('joven-portal-active');

    var railWidth = portal.getAttribute('data-rail-width') || '360';
    document.documentElement.style.setProperty('--joven-rail-width', railWidth + 'px');

    document.body.classList.toggle('joven-hide-theme-chrome', portal.getAttribute('data-hide-theme-chrome') === 'true');

    var requireLogin = portal.getAttribute('data-require-login') === 'true';
    var loggedIn = portal.getAttribute('data-customer-logged-in') === 'true';
    var isThemeEditor = window.Shopify && window.Shopify.designMode;
    if (requireLogin && !loggedIn && !isThemeEditor) {
      var loginUrl = portal.getAttribute('data-login-url');
      if (loginUrl) {
        window.location.replace(loginUrl);
        return;
      }
    }

    var links = Array.prototype.slice.call(portal.querySelectorAll('.joven-navitem[href^="#"]'));
    var targets = links.map(function (link) {
      try { return document.querySelector(link.getAttribute('href')); }
      catch (error) { return null; }
    }).filter(Boolean);

    function setActive(id) {
      links.forEach(function (link) {
        link.classList.toggle('is-active', link.getAttribute('href') === '#' + id);
      });
    }

    links.forEach(function (link) {
      link.addEventListener('click', function () {
        setActive(link.getAttribute('href').slice(1));
      });
    });

    if ('IntersectionObserver' in window && targets.length) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      }, { rootMargin: '-42% 0px -48% 0px', threshold: 0 });
      targets.forEach(function (target) { observer.observe(target); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPortal);
  } else {
    initPortal();
  }

  document.addEventListener('shopify:section:load', initPortal);
})();